import React, { memo, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, css, glyphs } from "../../../Styles";
import { ProgressCircle, UNIT, LOCATIONLIST, MotorSpecs, AnimalFeedView} from "../../";
import { Graph_QL, useFeedCurves, Location, System, Consumption, useTerminals, SectionsInfo } from "../../../Services";
import { useAppSelector } from "../../../Store";
import { selectFeedCurveById } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/FeedDataSlices/feedCurvesSlice";
import { NavigationFunction as RootNavigation, Pages } from "../../../Navigation/root";
import { useNavigate } from "react-router";
import { LocationListTypes } from "../../Animals/_Animals/locationContext";
import { useDispatch } from "react-redux";
import { SET_ACTIVE_PEN } from "../../../Store/UI/modalRedirectSlice";
import { Animal } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall";
import { useSingleConsumption } from "../../_Components/consumption";
import { NewProgressCicle } from "../../_Components";

interface penModal_Props {
  activePen?: Location;
  section?: SectionsInfo
  system: System
}

/**
 * PenModal
 * @param activePenId The pen number.
 * @returns A "div" to place in a modal to show all content from a Location Feeder Pen.
 */
export default function PenModal({ system, section, activePen }: penModal_Props) {
  const { t } = useTranslation();
  const navigator = useNavigate();
  const dispatchRoute = useDispatch();
  
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(()=> (Graph_QL.ObjToString({domain: farm ?? ""})),[farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);
  
  const { call: getFeedCurves } = useFeedCurves(connection);
  const { call: getTerminals, data: terminals } = useTerminals(connection)  

  useEffect(() => {
    getFeedCurves({ fetchAmount: 50, ifFeedCurveBaseInfoOnly: false })
    getTerminals({ })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const terminalsForPen = useMemo(() => terminals[domain]?.data?.filter(
      terminal => terminal.fk_locations === activePen?.location_id
  ), [terminals, domain, activePen?.location_id]);

  const activeAnimal = useMemo(() => ({
    animal: activePen?.animals?.[0],
  }), [activePen]);

  const feedCurve = useAppSelector((state) =>  {if (activeAnimal.animal?.feedcurve_id === undefined) { return }; return selectFeedCurveById(state, activeAnimal.animal?.feedcurve_id)})
  
  const progressCircles = useMemo(() => {
    return ( <div style={{display: "flex"}}>
      <NewProgressCicle animals={activeAnimal.animal ? [activeAnimal.animal] : []} connect={{domain: domain, connection: connection}} circleId={1} />
      <NewProgressCicle animals={activeAnimal.animal ? [activeAnimal.animal] : []} connect={{domain: domain, connection: connection}} circleId={2} />
    </div> )
  }, [activeAnimal, domain, connection]);

  return ( <>
    <div style={{ ...css.modalTop, height: "200px", alignItems: "center"}}>
      
      <MotorSpecs terminals={terminalsForPen} farm={farm}/>

      <div style={{display: "flex"}}>
       {progressCircles}
      </div>
      
    </div>
    <div style={{...css.seperatorLine}}/>

    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center"}}>
      {activeAnimal.animal ? ( <>
        {/* Pen/PenEdit based on PenMode */}
          {activePen ?
            <LOCATIONLIST
              key={activePen.location_id}
              listType={LocationListTypes.animals}
              headerPen={true} systemType={system.fk_system_types}
              pens={[activePen]}
              onAnimalClick={(animalId: number) => {
                if (activePen && section) {
                  dispatchRoute(SET_ACTIVE_PEN({ type: "lf", location: activePen, group: section, system: system.system_id }));
                }
              
                RootNavigation({
                  Navigator: navigator,
                  navigation_page: Pages.animals,
                  navigation_tab: Pages.animal,
                  replace: true,
                  navArgs: { selected: animalId },
                  currentDomain: farm
                });
              }}
              connect={{ connection: connection, farm: farm, domain: domain }}
            />
          : <></>}
        <div style={{marginTop: "20px"}}><AnimalFeedView feedCurve={feedCurve} activeAnimal={activeAnimal.animal}/></div>
      </> )
        
      // IF NO ANIMAL
      : (
        <p style={{ ...css.emptyPen, opacity: "0.5", marginBottom: "10px"}}>
          {t("locationFeederPages.sections.emptyPen", {defaultValue: "Empty pen"})}
        </p>
      )}
    </div>
  </> );
}

// export const RemainingToday = memo(({animal}: {animal?: Animal}) => {
//   const { t } = useTranslation();

//   if (!animal) return;
//   const consumptionData = useSingleConsumption(animal?.animal_id ?? 0)[0]

//   return (
//     <ProgressCircle
//       total={consumptionData.feed.total}
//       progressed={consumptionData.feed.remaning}
//       animation
//       labels={{
//         header: t("feed.general.remainingToday", { defaultValue: "remaining today" }),
//         unit: <UNIT content={"KG"} color={colors.greyPrimary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyPrimary}/>}/>
//       }}
//       extension={{
//         hasExtension: true
//       }}
//     />
//   );
// })

// export const RemainingYesterday = memo(({animal}: {animal?: Animal}) => {
//   const { t } = useTranslation();
//   const consumptionData = useSingleConsumption(animal?.animal_id ?? 0)[1]

//   return (
//     <ProgressCircle
//       total={consumptionData.feed.total}
//       progressed={consumptionData.feed.remaning}
//       animation
//       labels={{
//         header: t("feed.general.remainingYesterday", { defaultValue: "remaining yesterday" }),
//         unit: <UNIT content={"KG"} color={colors.greyPrimary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyPrimary}/>}/>
//       }}
//       extension={{
//         hasExtension: true
//       }}
//     />
//   );
// })